<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<form #df="ngForm" novalidate class="formborder">
  <div class="row m-0 col-md-12 p-0">
    <div class="col-md-2">
      <span class="required-lable"> DueUp To  </span>
      <div class="datepicker_feild">
        <input
          [matDatepicker]="picker"
          dateConvert
          placeholder="DD/MM/YYYY"
          name="searchDate"
          id="searchDate"
          required
          #refsearchDate="ngModel"
          class="form-control input-text-css"
          [(ngModel)]="searchDate"
          [ngClass]="{
            'is-invalid': df.submitted && refsearchDate.invalid,
            'alert-warning':
              refsearchDate.invalid &&
              (refsearchDate.dirty ||
                refsearchDate.touched ||
                refsearchDate.untouched)
          }"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>
    <div class="col-md-4">
      <button
        type="button"
        (click)="GetReportPortfolioDifference()"
        class="mt-3 btn font-size-12 button-btn"
        [disabled]="!df.form.valid"
      >
        Search
      </button>
    </div>

    <div class="col-md-4 mt-3" [hidden]="!dataSource">
      <form action="" class="search-text">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input
              type="text"
              id="FilterInputSearch"
              (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch"
              placeholder="What're you searching for?"
              class="form-control border-0 bg-light"
            />
            <div class="input-group-append">
              <button
                id="button-addon1"
                type="submit"
                class="btn btn-link text-primary"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- Table -->
  <div class="mt-3" [hidden]="!dataSource">
    <div class="">
      <div class="table-responsive" style="overflow: auto; height: 65vh">
        <table
          mat-table
          class="table-bordered"
          matSort
          [dataSource]="dataSource"
          matTableExporter
          #exporter="matTableExporter"
          id="DueList"
        >
        <ng-container matColumnDef="ParticularsGroup">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="6" class="group-header-cell">
            Particulars
          </th>
        </ng-container>

        <ng-container matColumnDef="LoanStockGroup">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="group-header-cell">
            Loan Stock
          </th>
        </ng-container>

        <ng-container matColumnDef="PartnerStockGroup">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="group-header-cell">
            Partner Stock
          </th>
        </ng-container>

        <ng-container matColumnDef="LoanInstallmentGroup">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="group-header-cell">
            Loan Installment
          </th>
        </ng-container>

        <ng-container matColumnDef="PartnerInstallmentGroup">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="group-header-cell">
            Partner Installment
          </th>
        </ng-container>

        <ng-container matColumnDef="LoanInterestGroup">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="group-header-cell">
            Loan Interest
          </th>
        </ng-container>

        <ng-container matColumnDef="PartnerInterestGroup">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="group-header-cell">
            Partner Interest
          </th>
        </ng-container>

        <ng-container matColumnDef="Id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index">
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </td>
          <th mat-footer-cell *matFooterCellDef></th>
        </ng-container>
          <ng-container matColumnDef="LoanAcNo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              LoanAcNo
            </th>
            <td mat-cell *matCellDef="let row">{{ row.LoanAcNo }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PLoanAcNo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>PLoanAcNo</th>
            <td mat-cell *matCellDef="let row">{{ row.PLoanAcNo }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Branch_Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Branch Name</th>
            <td mat-cell *matCellDef="let row">{{ row.Branch_Name }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Product_Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
            <td mat-cell *matCellDef="let row">{{ row.Product_Name }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="Customer_Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
            <td mat-cell *matCellDef="let row">{{ row.CustomerName }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="LoanStockDR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Loan Stock DR</th>
            <td mat-cell *matCellDef="let row">{{ row.LoanStockDR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="LoanStockCR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Loan Stock CR
            </th>
            <td mat-cell *matCellDef="let row" class="text-right">
              {{ row.LoanStockCR }}
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="LoanStockBalance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Loan Stock Balance
            </th>
            <td mat-cell *matCellDef="let row">{{ row.LoanStockBalance }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PartnerStockDR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Partner Stock DR
            </th>
            <td mat-cell *matCellDef="let row">{{ row.PartnerStockDR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PartnerStockCR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Partner Stock CR</th>
            <td mat-cell *matCellDef="let row">{{ row.PartnerStockCR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PartnerStockBalance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Partner Stock Balance
            </th>
            <td mat-cell *matCellDef="let row">{{ row.PartnerStockBalance }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="LoanInstallmentDR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Loan Installment DR</th>
            <td mat-cell *matCellDef="let row">{{ row.LoanInstallmentDR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="LoanInstallmentCR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Loan Installment CR
            </th>
            <td mat-cell *matCellDef="let row">{{ row.LoanInstallmentCR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="LoanInstallmentBalance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Loan Installment Balance</th>
            <td mat-cell *matCellDef="let row">
              {{ row.LoanInstallmentBalance }}
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PartnerInstallmentDR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Partner Installment DR
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.PartnerInstallmentDR }}
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PartnerInstallmentCR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Partner Installment CR
            </th>
            <td mat-cell *matCellDef="let row">{{ row.PartnerInstallmentCR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PartnerInstallmentBalance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Partner Installment Balance
            </th>
            <td mat-cell *matCellDef="let row">{{ row.PartnerInstallmentBalance }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="LoanInterestDR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Loan Interest DR
            </th>
            <td mat-cell *matCellDef="let row">{{ row.LoanInterestDR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>
    
          <ng-container matColumnDef="LoanInterestCR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Loan Interest CR</th>
            <td mat-cell *matCellDef="let row">{{ row.LoanInterestCR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="LoanInterestBalance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Loan Interest Balance
            </th>
            <td mat-cell *matCellDef="let row">{{ row.LoanInterestBalance }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PartnerInterestDR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Partner Interest DR
            </th>
            <td mat-cell *matCellDef="let row">{{ row.PartnerInterestDR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PartnerInterestCR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Partner Interest CR
            </th>
            <td mat-cell *matCellDef="let row">{{ row.PartnerInterestCR }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

          <ng-container matColumnDef="PartnerInterestBalance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Partner Interest Balance
            </th>
            <td mat-cell *matCellDef="let row">{{ row.PartnerInterestBalance }}</td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="groupedHeaderColumns; sticky: true"
            class="sticky-footer fontcolor group-header-row"
            style="background: #4dc3a3"
          ></tr>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
            class="sticky-footer fontcolor"
            style="background: #4dc3a3"
          ></tr>
          <tr
            mat-row
            (click)="highlightRow(row)"
            [class.highlight]="row.LoanAcNo == selectedId"
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
        </table>
      </div>
    </div>
  </div>
  <div class="row m-0 ml-3" [hidden]="!dataSource">
  <div class="col-md-4 mt-3">
    <button class="mt-3 btn font-size-12 button-btn" (click)="exportexcelNew()">
      <i
        class="fa fa-file-export mr-1"
        style="font-size: medium; cursor: pointer"
      ></i>
      Export
    </button>
  </div>
  <div class="col-md-8 mt-3">
    <mat-paginator
      #paginatorRef
      [pageSizeOptions]="[20, 50]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
</form>
<table
  id="partner_balance_compare"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <thead>
    <tr>
      <th colspan="6" style="background: #4dc3a3 !important; border: 1px solid white; text-align: center;">Particulars</th>
      <th colspan="3" style="background: #4dc3a3 !important; border: 1px solid white; text-align: center;">Loan Stock</th>
      <th colspan="3" style="background: #4dc3a3 !important; border: 1px solid white; text-align: center;">Partner Stock</th>
      <th colspan="3" style="background: #4dc3a3 !important; border: 1px solid white; text-align: center;">Loan Installment</th>
      <th colspan="3" style="background: #4dc3a3 !important; border: 1px solid white; text-align: center;">Partner Installment</th>
      <th colspan="3" style="background: #4dc3a3 !important; border: 1px solid white; text-align: center;">Loan Interest</th>
      <th colspan="3" style="background: #4dc3a3 !important; border: 1px solid white; text-align: center;">Partner Interest</th>
    </tr>
    <tr>
      <th style="background: #4dc3a3 !important; border: 1px solid white">#</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanAcNo</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PLoanAcNo</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">BranchName</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">ProductName</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">CustomerName</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanStockDR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanStockCR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanStockBalance</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PartnerStockDR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PartnerStockCR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PartnerStockBalance</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanInstallmentDR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanInstallmentCR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanInstallmentBalance</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PartnerInstallmentDR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PartnerInstallmentCR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PartnerInstallmentBalance</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanInterestDR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanInterestCR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">LoanInterestBalance</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PartnerInterestDR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PartnerInterestCR</th>
      <th style="background: #4dc3a3 !important; border: 1px solid white">PartnerInterestBalance</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let x of JsonData; let i = index">
      <td>{{ i + 1 }}</td>
      <td style="mso-number-format:'\@';">{{ x.LoanAcNo }}</td>
      <td style="mso-number-format:'\@';">{{ x.PLoanAcNo }}</td>
      <td>{{ x.Branch_Name }}</td>
      <td>{{ x.Product_Name }}</td>
      <td>{{ x.CustomerName }}</td>
      <td>{{ x.LoanStockDR }}</td>
      <td>{{ x.LoanStockCR }}</td>
      <td>{{ x.LoanStockBalance }}</td>
      <td>{{ x.PartnerStockDR }}</td>
      <td>{{ x.PartnerStockCR }}</td>
      <td>{{ x.PartnerStockBalance }}</td>
      <td>{{ x.LoanInstallmentDR }}</td>
      <td>{{ x.LoanInstallmentCR }}</td>
      <td>{{ x.LoanInstallmentBalance }}</td>
      <td>{{ x.PartnerInstallmentDR }}</td>
      <td>{{ x.PartnerInstallmentCR }}</td>
      <td>{{ x.PartnerInstallmentBalance }}</td>
      <td>{{ x.LoanInterestDR }}</td>
      <td>{{ x.LoanInterestCR }}</td>
      <td>{{ x.LoanInterestBalance }}</td>
      <td>{{ x.PartnerInterestDR }}</td>
      <td>{{ x.PartnerInterestCR }}</td>
      <td>{{ x.PartnerInterestBalance }}</td>
    </tr>
  </tbody>
</table>
